module.exports = __webpack_public_path__ + "bg-hero.jpg";